import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { GetTargetsRequest, GetTargetsResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class CompanyFilterBaseDataProvider extends BaseWebComponentDataProvider {
  async getInitialTargets(request: GetTargetsRequest): Promise<GetTargetsResponse | undefined> {
    throw new Error('Needs to be implemented');
  }

  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    throw new Error('Needs to be implemented');
  }
}
